import type {RepoIssuesDashboardContentResponse} from '@github-ui/dotcom-schema/types/issues/v1/repo_issues_dashboard'
import {replaceDateTokens} from '@github-ui/issue-url-helper'
import {makeSelectDataFromQueryData} from '@github-ui/react-core/future/main-query'
import {queryOptions} from '@github-ui/react-query'

import {issuesIndexContentRoute} from './issues-index-content-route'

export function savedViewIssuesQueryOptions({
  owner,
  repo,
  query,
  page,
}: {
  owner: string
  repo: string
  query: string
  page: number
}) {
  const resolvedQuery = replaceDateTokens(query)
  const queryDeps = {
    pathname: `/${owner}/${repo}/issues`,
    searchParams: {q: resolvedQuery, page: String(page)},
  }
  // creates the same canonical key used by the issues index route
  const queryKey = issuesIndexContentRoute.queries.mainQuery.makeQueryKey(queryDeps)

  return queryOptions({
    ...issuesIndexContentRoute.buildQueryOptions('mainQuery', queryKey),
    select: makeSelectDataFromQueryData<RepoIssuesDashboardContentResponse>(),
  })
}
